import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/enroll-popup-close-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-48ee0e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tm-rule-popup" }
const _hoisted_2 = { class: "pop-box-wrapper" }
const _hoisted_3 = { class: "popup-box" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mask",
      onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, null, 32),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "content",
          innerHTML: _ctx.gameRule
        }, null, 8, _hoisted_4),
        _createElementVNode("div", {
          class: "know-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTmRulePopup(false)))
        }, "我知道了"),
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTmRulePopup(false)))
        }, _hoisted_6)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.isShowTmRulePopup]
  ])
}